// extracted by mini-css-extract-plugin
export default {"sideText":"securityVerificationModal_sideText__gdqeO"};